import Styles from "@/base/styles/SkeletonLoading.module.scss";

type Props = {
	className?: string,
	children?: any,
	loading?: boolean,
};


export const SkeletonLoading = ({
	className = '',
	children = null,
	loading = false
}: Props) => {
	return (
		<div className={`${className} ${loading ? Styles.skeleton : ''}`}>
			{children}
		</div>
	);
};
